import React, {useEffect, useState} from "react";
import "../App.css";
import axios from "axios";
import {ColorModeIcon} from "../context/ColorModeContext.tsx";

import Navbar from "../components/Navbar.tsx";

import {SubmitButton} from "../components/Buttons.tsx";
import SearchableSelect from "../components/SearchableSelect.tsx";
import {Helmet} from "react-helmet";

import "../CSS/programmes/StatisticsAnalyzer.css"

import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, {Dayjs} from "dayjs";
import {DatePicker} from "@mui/x-date-pickers";
import CustomCheckbox from "../components/CustomCheckbox.tsx";


interface userData {
  id: number;
  username: string;
  role: string;
}

const TAB_NAMES: string[] = [
  "Stammdaten",     // 1
  "Preisangaben",   // 2
  "Kategorien",     // 3
  "Metriken",       // 4
  "Produkttexte",   // 5
  "Bilder",          // 6
];

const formatTime = (seconds: number) => {
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  return `${m}:${s.toString().padStart(2, "0")}`;
};

function StatisticsAnalyzer() {
  const backendUrl = import.meta.env.VITE_REACT_APP_BACKEND_URL;

  const [users, setUsers] = useState<{ value: string, label: string } []>([]);
  const [selectedUser, setSelectedUser] = useState<string | null>(null);
  const [dateRange, setDateRange] = useState<[Dayjs | null, Dayjs | null]>([null, null]);


  const [statistics, setStatistics] = useState<any[] | null>([]); // Will store the backend results


  const [infoMessage, setinfoMessage] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {

    const fetchData = async () => {
      try {
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        };

        const response = await axios.get<userData[]>(`${backendUrl}/item_creator/get_users/`, config)
        console.log(response)
        // The return will be something like [{id, username, role}, {id, username, role}, ...]
        const formattedData = response.data.map((u) => ({value: u.username, label: u.username,}));
        setUsers(formattedData);
      } catch (error) {
        setErrorMessage("Fehler beim laden der Benutzer. Bitte lade die Seite erneut.");
      }
    };

    fetchData();

  }, []);

  const renderSelections = () => {
    return (
      <div className="StatisticsAnalyzerPage">
        <h3>Analysiere mit diesem Programm die Artikel Erstellung</h3>
        <SearchableSelect
          inputLabel={"Benutzer"}
          items={users}
          value={selectedUser ? {value: selectedUser, label: selectedUser} : null}
          setValue={(newVal) => setSelectedUser(newVal ? newVal.value : null)}
          is_required={false}
          sx={{width: "50%"}}
        />
        <div>
          <p>Wählst du nur das Startdatum aus, werden alle danach erstellten Artikel angezeigt. Um einen bestimmten
            Tag </p>
          <p>anzeigen zu lassen, wähle diesen Tag sowohl als Start- als auch Enddatum aus</p></div>
        <div style={{display: "flex", flexDirection: "row", gap: "15px"}}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            {/* Start Date */}
            <DatePicker
              label="Startdatum"
              value={dateRange[0]}
              maxDate={dateRange[1] || undefined}
              onChange={(newVal) => {
                setDateRange(([_, end]) => {
                  if (end && newVal && end.isBefore(newVal, "day")) {
                    return [newVal, null];
                  }
                  return [newVal, end];
                });
              }}
              format="DD/MM/YYYY"
              slotProps={{
                field: {clearable: true},
                textField: {
                  helperText: "DD/MM/YYYY",

                  // 1. Styles for the INPUT container (Border, Icons, Text Value)
                  InputProps: {
                    sx: {
                      color: "var(--font-primary)", // The typed text color

                      // The Icons (Calendar + Clear X)
                      "& .MuiSvgIcon-root": {
                        color: "var(--font-primary)",
                      },

                      // The Border (Technically called the notchedOutline)
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "var(--naturGreen)",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "var(--naturGreen)",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "var(--naturGreen)",
                      },
                    },
                  },

                  // 2. Styles for the LABEL ("Startdatum")
                  InputLabelProps: {
                    sx: {
                      color: "var(--font-primary)",
                      "&.Mui-focused": {
                        color: "var(--font-primary)",
                      },
                    },
                  },

                  // 3. Styles for the HELPER TEXT ("DD/MM/YYYY")
                  FormHelperTextProps: {
                    sx: {
                      color: "var(--font-primary)",
                    },
                  },
                },
              }}
            />

            {/* End Date */}
            <DatePicker
              label="Enddatum"
              value={dateRange[1]}
              disabled={!dateRange[0]}   // Can't pick end before start
              minDate={dateRange[0] || undefined}  // Force end >= start
              onChange={(newVal) => {
                setDateRange(([start, _]) => [start, newVal]);
              }}
              format="DD/MM/YYYY"
              slotProps={{
                field: {clearable: true},
                textField: {
                  // 1. Styles for the INPUT container (Border, Icons, Text Value)
                  InputProps: {
                    sx: {
                      color: "var(--font-primary)", // The typed text color

                      // The Icons (Calendar + Clear X)
                      "& .MuiSvgIcon-root": {
                        color: "var(--font-primary)",
                      },

                      // The Border (Technically called the notchedOutline)
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "var(--naturGreen)",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "var(--naturGreen)",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "var(--naturGreen)",
                      },
                    },
                  },

                  // 2. Styles for the LABEL ("Startdatum")
                  InputLabelProps: {
                    sx: {
                      color: "var(--font-primary)",
                      "&.Mui-focused": {
                        color: "var(--font-primary)",
                      },
                    },
                  },

                  // 3. Styles for the HELPER TEXT ("DD/MM/YYYY")
                  FormHelperTextProps: {
                    sx: {
                      color: "var(--font-primary)",
                    },
                  },
                },
              }}
            />
          </LocalizationProvider>
        </div>
      </div>
    );
  };

  const renderErrorMessage = () => {
    if (errorMessage) {
      return (
        <div className="error-message-container">
          {" "}
          <p>{errorMessage}</p>{" "}
        </div>
      );
    } else {
      return null;
    }
  };

  const renderInfoMessage = () => {
    if (infoMessage) {
      return (
        <div className="info-message-container">
          {" "}
          <p>{infoMessage}</p>{" "}
        </div>
      );
    } else {
      return null;
    }
  };

  const handleGoButton = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    setinfoMessage(null);
    setErrorMessage(null);

    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };

      // Build query parameters dynamically
      const params = new URLSearchParams();

      if (selectedUser) params.append("username", selectedUser);

      const [startDate, endDate] = dateRange;
      if (startDate) params.append("start_date", startDate.format("YYYY-MM-DD"));
      if (endDate) params.append("end_date", endDate.format("YYYY-MM-DD"));

      const finalUrl = `${backendUrl}/item_creator/get_statistics/${
        params.toString() ? "?" + params.toString() : ""
      }`;

      const res = await axios.get(finalUrl, config);

      setStatistics(res.data);
      setinfoMessage("Daten erfolgreich geladen");
    } catch (err) {
      const error_str =
        !err.response
          ? "Netzwerkfehler. Deine Internetverbindung ist entweder unterbrochen oder der Server ist nicht erreichbar."
          : err.response.status === 500
            ? "Interner Serverfehler. Bitte mache einen Screenshot und schicke ihn an Jonathan."
            : err.response.data.detail?.toString();

      setErrorMessage(error_str);
      alert(error_str);
    }
  };

  const renderStatisticsTable = () => {
    if (!statistics || statistics.length === 0) return null;

    const formatDate = (dateStr: string) => {
      const d = dayjs(dateStr);
      return d.format("DD.MM.YYYY");
    };

    return (
      <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
        <p style={{marginTop: "20px", fontWeight: "bold"}}>
          Es wurden {statistics.length} Einträge gefunden.
        </p>
        <table style={{width: "100%", borderCollapse: "collapse", marginTop: "20px"}}>
          <thead>
          <tr style={{borderBottom: "2px solid #ccc", textAlign: "center"}}>
            <th style={{padding: "10px", width: "3%"}}>Kopie?</th>
            <th style={{padding: "10px", width: "5%"}}>Datum</th>
            <th style={{padding: "10px", width: "4%"}}>Bearbeitungszeitraum</th>
            <th style={{padding: "10px", width: "5%"}}>Ersteller</th>
            <th style={{padding: "10px", width: "1%"}}>Zeit</th>
            <th style={{padding: "10px", width: "5%"}}>Artikel-ID</th>
            <th style={{padding: "10px", width: "10%"}}>Zeit pro Tab</th>
            <th style={{padding: "10px", width: "1%"}}>Kategorie</th>
            <th style={{padding: "10px", width: "1%"}}>Lieferant</th>
          </tr>
          </thead>

          <tbody>
          {statistics.map((entry, idx) => (
            <tr key={idx} style={{borderBottom: "1px solid #eee", textAlign: "center"}}>

              {/* Copy flag with CustomCheckbox */}
              <td style={{padding: "10px"}}>
                <CustomCheckbox
                  label={""}
                  value={entry.is_copy_article}
                  onChange={() => {
                  }}
                  is_disabled={true}
                />
              </td>

              {/* Date */}
              <td style={{padding: "10px"}}>{formatDate(entry.datum)}</td>
              <td style={{padding: "10px"}}>
                {entry.start_time ? dayjs(entry.start_time).format("HH:mm") : "-"} bis {entry.end_time ? dayjs(entry.end_time).format("HH:mm") : "-"}
              </td>

              {/* Username */}
              <td style={{padding: "10px"}}>{entry.username}</td>

              {/* Total time */}
              <td style={{padding: "10px"}}>{formatTime(entry.total_time)}</td>


              {/* Item ID */}
              <td style={{padding: "10px"}}>{entry.item_id}</td>

              {/* Time per tab */}
              <td style={{padding: "10px", textAlign: "left"}}>
                <ul style={{margin: 0, paddingLeft: "20px"}}>
                  {Object.entries(entry.time_per_tab).map(([tab, value]) => (
                    <li key={tab}>
                      {TAB_NAMES[Number(tab)]}: {value as number}s
                    </li>
                  ))}
                </ul>
              </td>

              {/* Category name (id) */}
              <td style={{padding: "10px"}}>
                {entry.category_name} ({entry.category_id})
              </td>

              {/* Supplier name (id) */}
              <td style={{padding: "10px"}}>
                {entry.supplier_name} ({entry.supplier_id})
              </td>

            </tr>
          ))}
          </tbody>
        </table>
      </div>
    );
  };


  return (
    <>
      <Navbar/>
      <Helmet>
        <title>{"Ersteller-Statistik"}</title>
      </Helmet>
      {renderSelections()}
      <SubmitButton
        label={"Informationen laden"}
        onClick={handleGoButton}
        size="small"
        type="submit"
        sx={{width: "50%", marginTop: "15px"}}
      />
      {renderErrorMessage()}
      {renderInfoMessage()}
      {ColorModeIcon()}
      {renderStatisticsTable()}
    </>
  );
}

export default StatisticsAnalyzer;
